import {
   ACCIDENT_PARTIES_AT_FAULT_OPTIONS,
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator";
import {transformValidationResultToArray} from "@utils/validation-markup-generator";


export const ValidateStep4Data = (data) => {
   
   let rules = [
      
      {
         field_name: 'hasAccidentClaimsInLast5Years',
         field_label: 'Accident claims in last 5 years',
         rules: [
            {
               name: 'required',
               message: 'Please specify if you had any accident claims in the last 5 years'
            },
            {name: 'string'},
            {
               name: 'in_array',
               data: {
                  array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
               },
               message: 'Invalid selection for accident claims in last 5 years'
            }
         ]
      },
      
      {
         field_name: 'motorAccidentsList',
         field_label: 'Motor accidents list',
         rules: [
            {
               name: 'custom',
               validateFunction: (value, allData) => {
                  if (allData.hasAccidentClaimsInLast5Years === 'Yes') {
                     return Array.isArray(value) && value.length > 0;
                  }
                  
                  return true;
               },
               message: 'Please add at least one motor accident or claim detail'
            }
         ]
      },
      {
         field_name: 'motorAccidentsList.*.type',
         field_label: 'Accident/claim type',
         rules: [
            {
               name: 'required',
               message: 'Please specify the accident/claim type @ Accident #{index}'
            },
            {name: 'string'},
         ]
      },
      {
         field_name: 'motorAccidentsList.*.date',
         field_label: 'Accident/claim date',
         rules: [
            {
               name: 'required',
               message: 'Please specify the accident/claim date @ Accident #{index}'
            },
            {
               name: 'date_string',
               data: {format: 'yyyy-MM-dd'},
               message: 'Invalid date format for accident/claim date @ Accident #{index}'
            },
            {
               name: 'date_string_before',
               data: {date: new Date().toISOString().split('T')[0], format: 'yyyy-MM-dd'},
               message: 'Accident/claim date cannot be in the future @ Accident #{index}'
            }
         ]
      },
      {
         field_name: 'motorAccidentsList.*.partyAtFault',
         field_label: 'Party at fault',
         rules: [
            {
               name: 'required',
               message: 'Please specify if you were at fault @ Accident #{index}'
            },
            {name: 'string'},
            {
               name: 'in_array',
               data: {
                  array: ACCIDENT_PARTIES_AT_FAULT_OPTIONS?.map(item => item.value)
               },
               message: 'Invalid selection for party at fault @ Accident #{index}'
            }
         ]
      },
      {
         field_name: 'hasMotoringConvictionsInLast5Years',
         field_label: 'Motoring convictions in last 5 years',
         rules: [
            {
               name: 'required',
               message: 'Please specify if you had any motoring convictions in the last 5 years'
            },
            {name: 'string'},
            {
               name: 'in_array',
               data: {
                  array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
               },
               message: 'Invalid selection for motoring convictions in last 5 years'
            }
         ]
      },
      
      {
         field_name: 'motorConvictionsList',
         field_label: 'Motoring convictions list',
         rules: [
            {
               name: 'custom',
               validateFunction: (value, allData) => {
                  if (allData.hasMotoringConvictionsInLast5Years === 'Yes') {
                     return Array.isArray(value) && value.length > 0;
                  }
                  
                  return true;
               },
               message: 'Please add at least one motoring conviction detail'
            }
         ]
      },
      {
         field_name: 'motorConvictionsList.*.date',
         field_label: 'Conviction date',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify the conviction date @ Conviction #{index}'
            },
            {
               name: 'date_string',
               data: {format: 'yyyy-MM-dd'},
               message: 'Invalid date format for conviction date @ Conviction #{index}'
            },
            {
               name: 'date_string_before',
               data: {date: new Date().toISOString().split('T')[0], format: 'yyyy-MM-dd'},
               message: 'Conviction date cannot be in the future @ Conviction #{index}'
            }
         ]
      },
      {
         field_name: 'motorConvictionsList.*.code',
         field_label: 'Conviction code',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify the conviction code @ Conviction #{index}'
            },
            {name: 'string'},
            {
               name: 'length_between',
               data: {min_length: 1, max_length: 10},
               message: 'Conviction code must be between 1 and 10 characters @ Conviction #{index}'
            }
         ]
      },
      {
         field_name: 'motorConvictionsList.*.points',
         field_label: 'Points',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify the points @ Conviction #{index}'
            },
            {name: 'integer'},
            {
               name: 'greater_or_equal',
               data: {target: 0},
               message: 'Points must be 0 or more @ Conviction #{index}'
            },
         ]
      },
      {
         field_name: 'motorConvictionsList.*.fines',
         field_label: 'Fines (£)',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify the fines (£) @ Conviction #{index}'
            },
            {name: 'number'},
            {
               name: 'greater_or_equal',
               data: {target: 0},
               message: 'Fines (£) must be 0 or more @ Conviction #{index}'
            },
         ]
      },
      {
         field_name: 'motorConvictionsList.*.banLengthInMonths',
         field_label: 'Ban length (months)',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify the ban length (months) @ Conviction #{index}'
            },
            {name: 'integer'},
            {
               name: 'greater_or_equal',
               data: {target: 0},
               message: 'Ban length (months) must be 0 or more @ Conviction #{index}'
            },
         ]
      },
      {
         field_name: 'motorConvictionsList.*.wasDriverBreathalysed',
         field_label: 'Was driver breathalysed',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify if the driver was breathalysed @ Conviction #{index}'
            },
            {name: 'string'},
            {
               name: 'in_array',
               data: {
                  array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
               },
               message: 'Invalid selection for was driver breathalysed @ Conviction #{index}'
            }
         ]
      },
      {
         field_name: 'motorConvictionsList.*.wasOffenceAccidentRelated',
         field_label: 'Was offence accident related',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasMotoringConvictionsInLast5Years',
                  value: 'Yes'
               },
               message: 'Please specify if the offence was accident related @ Conviction #{index}'
            },
            {name: 'string'},
            {
               name: 'in_array',
               data: {
                  array: YES_NO_CHOICE_OPTIONS?.map(item => item.value)
               },
               message: 'Invalid selection for was offence accident related @ Conviction #{index}'
            }
         ]
      }
   
   ];
   
   const validator = new ObjetDataValidator({
      data,
      rules
   });
   
   const result = validator.validate();
   
   if (result === true) {
      return [];
   } else {
      return transformValidationResultToArray(result);
   }
   
}